import { coerceBooleanProperty, _isNumberValue } from '@angular/cdk/coercion';
import { EventEmitter, Component, ChangeDetectionStrategy, ViewEncapsulation, Input, Output, NgModule } from '@angular/core';
import { ProductTypeEnum } from 'b2c-ui/util';
import { CommonModule } from '@angular/common';
import { NzAddOnModule } from 'ng-zorro-antd/core';
import { NzCardModule } from 'ng-zorro-antd/card';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzTagModule } from 'ng-zorro-antd/tag';
import { NzGridModule } from 'ng-zorro-antd/grid';
import { B2CSharedPipeModule, SharedDirectiveModule } from 'b2c-ui/core';
import { AddToWatchlistIcon, RankingBgIcon, B2cUiIconModule, B2CUiIconService } from 'b2c-ui-icon';
import { B2CNgzIconModule } from 'b2c-ui/ngz-icons';

/**
 * @fileoverview added by tsickle
 * Generated from: b2c-product-card.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from 'ng-zorro-antd/card';
import * as ɵngcc2 from '@angular/common';
import * as ɵngcc3 from 'ng-zorro-antd/core';
import * as ɵngcc4 from 'ng-zorro-antd/tooltip';
import * as ɵngcc5 from 'b2c-ui-icon';
import * as ɵngcc6 from 'ng-zorro-antd';
import * as ɵngcc7 from 'ng-zorro-antd/button';
import * as ɵngcc8 from 'ng-zorro-antd/tag';
import * as ɵngcc9 from 'b2c-ui/core';
import * as ɵngcc10 from 'ng-zorro-antd/grid';

function B2CProductCardComponent_h2_1_span_2_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r11 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r11.highLightPrefix);
} }
function B2CProductCardComponent_h2_1_span_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span");
    ɵngcc0.ɵɵtemplate(1, B2CProductCardComponent_h2_1_span_2_ng_container_1_Template, 2, 1, "ng-container", 10);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r9 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("nzStringTemplateOutlet", ctx_r9.highLightPrefix);
} }
function B2CProductCardComponent_h2_1_span_6_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r12 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r12.highLightSuffix);
} }
function B2CProductCardComponent_h2_1_span_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span");
    ɵngcc0.ɵɵtemplate(1, B2CProductCardComponent_h2_1_span_6_ng_container_1_Template, 2, 1, "ng-container", 10);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r10 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("nzStringTemplateOutlet", ctx_r10.highLightSuffix);
} }
function B2CProductCardComponent_h2_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "h2", 9);
    ɵngcc0.ɵɵpipe(1, "pnl");
    ɵngcc0.ɵɵtemplate(2, B2CProductCardComponent_h2_1_span_2_Template, 2, 1, "span", 6);
    ɵngcc0.ɵɵelementStart(3, "span");
    ɵngcc0.ɵɵtext(4);
    ɵngcc0.ɵɵpipe(5, "number");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(6, B2CProductCardComponent_h2_1_span_6_Template, 2, 1, "span", 6);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngClass", ctx_r0.performanceColor && ctx_r0.highLight !== 999999 ? ɵngcc0.ɵɵpipeBind2(1, 4, ctx_r0.highLight, "text") : "");
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.highLightPrefix && ctx_r0.highLight !== 999999);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ctx_r0.highLight === 999999 ? "-" : ɵngcc0.ɵɵpipeBind2(5, 7, ctx_r0.highLight, "1.2-2"));
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.highLightSuffix && ctx_r0.highLight !== 999999);
} }
function B2CProductCardComponent_span_2_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r13 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r13.highlightIndicator);
} }
function B2CProductCardComponent_span_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 11);
    ɵngcc0.ɵɵtemplate(1, B2CProductCardComponent_span_2_ng_container_1_Template, 2, 1, "ng-container", 10);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("nzStringTemplateOutlet", ctx_r1.highlightIndicator);
} }
function B2CProductCardComponent_div_3_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r14 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1("", ctx_r14.productName, " ");
} }
function B2CProductCardComponent_div_3_a_3_Template(rf, ctx) { if (rf & 1) {
    const _r17 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "a", 15);
    ɵngcc0.ɵɵlistener("click", function B2CProductCardComponent_div_3_a_3_Template_a_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r17); const ctx_r16 = ɵngcc0.ɵɵnextContext(2); return ctx_r16.onWatchListChange(ctx_r16.isWatchListAdded); });
    ɵngcc0.ɵɵelement(1, "b2c-ui-icon", 16);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵproperty("nzTooltipTitle", "Add to watchlist");
} }
const _c0 = function (a0, a1) { return { "d-flex justify-content-between": a0, "mt-2": a1 }; };
function B2CProductCardComponent_div_3_Template(rf, ctx) { if (rf & 1) {
    const _r19 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 12);
    ɵngcc0.ɵɵelementStart(1, "span", 13);
    ɵngcc0.ɵɵlistener("click", function B2CProductCardComponent_div_3_Template_span_click_1_listener() { ɵngcc0.ɵɵrestoreView(_r19); const ctx_r18 = ɵngcc0.ɵɵnextContext(); return ctx_r18.emitProductNameEvent(); });
    ɵngcc0.ɵɵtemplate(2, B2CProductCardComponent_div_3_ng_container_2_Template, 2, 1, "ng-container", 10);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(3, B2CProductCardComponent_div_3_a_3_Template, 2, 1, "a", 14);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction2(3, _c0, ctx_r2.watchlist, ctx_r2.productName));
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("nzStringTemplateOutlet", ctx_r2.productName);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r2.watchlist);
} }
function B2CProductCardComponent_div_4_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r20 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r20.productSubtitle);
} }
function B2CProductCardComponent_div_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 17);
    ɵngcc0.ɵɵtemplate(1, B2CProductCardComponent_div_4_ng_container_1_Template, 2, 1, "ng-container", 10);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("nzStringTemplateOutlet", ctx_r3.productSubtitle);
} }
function B2CProductCardComponent_div_6_span_6_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r22 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1("", ctx_r22.productChangeSuffix, " ");
} }
function B2CProductCardComponent_div_6_span_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span");
    ɵngcc0.ɵɵtemplate(1, B2CProductCardComponent_div_6_span_6_ng_container_1_Template, 2, 1, "ng-container", 10);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r21 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("nzStringTemplateOutlet", ctx_r21.productChangeSuffix);
} }
function B2CProductCardComponent_div_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 18);
    ɵngcc0.ɵɵpipe(1, "pnl");
    ɵngcc0.ɵɵelement(2, "i", 19);
    ɵngcc0.ɵɵpipe(3, "pnl");
    ɵngcc0.ɵɵelementStart(4, "span");
    ɵngcc0.ɵɵtext(5);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(6, B2CProductCardComponent_div_6_span_6_Template, 2, 1, "span", 6);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngClass", ctx_r4.performanceColor ? ɵngcc0.ɵɵpipeBind2(1, 5, ctx_r4.productChange, "text") : "");
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("nzType", ɵngcc0.ɵɵpipeBind2(3, 8, ctx_r4.productChange, "caret"))("nzTheme", "fill");
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate1("", ctx_r4.productChange, " ");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r4.productChangeSuffix);
} }
function B2CProductCardComponent_div_7_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵpipe(2, "number");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" Vol: ", ɵngcc0.ɵɵpipeBind2(2, 1, ctx_r5.productVolume, "0.2"), " ");
} }
const _c1 = function (a0) { return { "mt-4": a0 }; };
function B2CProductCardComponent_div_8_button_2_Template(rf, ctx) { if (rf & 1) {
    const _r25 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 26);
    ɵngcc0.ɵɵlistener("click", function B2CProductCardComponent_div_8_button_2_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r25); const ctx_r24 = ɵngcc0.ɵɵnextContext(2); return ctx_r24.buy.emit(); });
    ɵngcc0.ɵɵtext(1, "Buy ");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r23 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(1, _c1, !ctx_r23.productRanking > 0));
} }
function B2CProductCardComponent_div_8_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 20);
    ɵngcc0.ɵɵelementStart(1, "div");
    ɵngcc0.ɵɵtemplate(2, B2CProductCardComponent_div_8_button_2_Template, 2, 3, "button", 21);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "div", 22);
    ɵngcc0.ɵɵelementStart(4, "div", 23);
    ɵngcc0.ɵɵelementStart(5, "h2", 24);
    ɵngcc0.ɵɵtext(6);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(7, "b2c-ui-icon", 25);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r6 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r6.buyButton);
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵtextInterpolate(ctx_r6.productRanking);
} }
function B2CProductCardComponent_nz_tag_9_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "nz-tag", 27);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r7 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngClass", "bg-" + ctx_r7.productType.class);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r7.productType.name, " ");
} }
function B2CProductCardComponent_div_10_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r26 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1("", ctx_r26.insuranceDesc, " ");
} }
function B2CProductCardComponent_div_10_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵelement(1, "hr", 28);
    ɵngcc0.ɵɵelementStart(2, "span", 29);
    ɵngcc0.ɵɵtemplate(3, B2CProductCardComponent_div_10_ng_container_3_Template, 2, 1, "ng-container", 10);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r8 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("nzStringTemplateOutlet", ctx_r8.insuranceDesc);
} }
const _c2 = ["*"];
function ProductTagInterface() { }
if (false) {
    /** @type {?} */
    ProductTagInterface.prototype.name;
    /** @type {?} */
    ProductTagInterface.prototype.class;
}
/** @type {?} */
const productTypeModel = [
    { type: ProductTypeEnum.UNIT_TRUST, name: 'UTs', class: 'fund' },
    { type: ProductTypeEnum.BOND, name: 'Bonds', class: 'bond' },
    { type: ProductTypeEnum.STOCK, name: 'Stocks', class: 'stock' },
    { type: ProductTypeEnum.ETF, name: 'ETFs', class: 'etf' },
    { type: ProductTypeEnum.INSURANCE, name: 'Term Life', class: 'insurance' },
    { type: ProductTypeEnum.DPMS, name: 'Managed Portfolio', class: 'map' }
];
/**
 * ##### Import this component individually to your module
 * `import { B2CProductCardModule } from 'b2c-ui/product-card';`
 */
class B2CProductCardComponent {
    constructor() {
        /**
         * @ignore
         */
        this._watchlist = false;
        /**
         * @ignore
         */
        this._buyButton = false;
        /**
         * @ignore
         */
        this._productType = this.getProductTagProperties();
        /**
         * Product name click event
         */
        this.productNameEvent = new EventEmitter();
        /**
         * Set performance color
         */
        this.performanceColor = true;
        /**
         * Set added watch list
         */
        this.isWatchListAdded = false;
        /**
         * Watchlist Change
         */
        this.watchListChange = new EventEmitter();
        /**
         * Buy button Change
         */
        this.buy = new EventEmitter();
    }
    /**
     * Set Product Highlight
     * @param {?} value
     * @return {?}
     */
    set highLight(value) {
        if (typeof value !== 'number') {
            throw new Error(`You provided ${typeof value} to highLight where a 'number' was expected`);
        }
        else {
            this._highLight = value;
        }
    }
    /**
     * @return {?}
     */
    get highLight() {
        return this._highLight;
    }
    /**
     * Set product change
     * @param {?} value
     * @return {?}
     */
    // @Input() productChange: number;
    set productChange(value) {
        this._productChange = value;
    }
    /**
     * @return {?}
     */
    get productChange() {
        return this._productChange;
    }
    /**
     * Set watchlist
     * @param {?} value
     * @return {?}
     */
    set watchlist(value) {
        this._watchlist = coerceBooleanProperty(value);
    }
    /**
     * @return {?}
     */
    get watchlist() {
        return this._watchlist;
    }
    /**
     * Set buy button
     * @param {?} value
     * @return {?}
     */
    set buyButton(value) {
        this._buyButton = coerceBooleanProperty(value);
    }
    /**
     * @return {?}
     */
    get buyButton() {
        return this._buyButton;
    }
    /**
     * Setter for productTag `ut | dpms | bond | insurance | stock | etf`
     * @param {?} value
     * @return {?}
     */
    set productTag(value) {
        if (typeof value !== 'number') {
            this._productType = this.getProductTagProperties(value);
        }
        else {
            this._productTag = value;
        }
    }
    /**
     * @return {?}
     */
    get productTag() {
        return this._productTag;
    }
    /**
     * @return {?}
     */
    get productType() {
        return this._productType;
    }
    /**
     * @ignore
     * @private
     * @param {?=} value
     * @return {?}
     */
    getProductTagProperties(value) {
        /** @type {?} */
        const productType = value;
        /** @type {?} */
        const tagProperty = {
            name: '',
            class: ''
        };
        if (typeof productType !== 'number') {
            for (const item of productTypeModel) {
                switch (productType) {
                    case item.type:
                        tagProperty.name = item.name;
                        tagProperty.class = item.class;
                        break;
                }
            }
        }
        return tagProperty;
    }
    /**
     * @ignore
     * @param {?} value
     * @return {?}
     */
    onWatchListChange(value) {
        this.watchListChange.emit(value);
    }
    /**
     * @ignore
     * @param {?} value
     * @return {?}
     */
    isNumberValue(value) {
        return _isNumberValue(value);
    }
    /**
     * @ignore
     * @return {?}
     */
    emitProductNameEvent() {
        this.productNameEvent.emit();
    }
}
B2CProductCardComponent.ɵfac = function B2CProductCardComponent_Factory(t) { return new (t || B2CProductCardComponent)(); };
B2CProductCardComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: B2CProductCardComponent, selectors: [["b2c-product-card"]], inputs: { performanceColor: "performanceColor", isWatchListAdded: "isWatchListAdded", highLight: "highLight", productChange: "productChange", watchlist: "watchlist", buyButton: "buyButton", productTag: "productTag", highLightPrefix: "highLightPrefix", highLightSuffix: "highLightSuffix", highlightIndicator: "highlightIndicator", productName: "productName", productSubtitle: "productSubtitle", productChangeSuffix: "productChangeSuffix", productVolume: "productVolume", fundType: "fundType", currency: "currency", insuranceDesc: "insuranceDesc", productRanking: "productRanking" }, outputs: { productNameEvent: "productNameEvent", watchListChange: "watchListChange", buy: "buy" }, exportAs: ["b2cProductCard"], ngContentSelectors: _c2, decls: 11, vars: 9, consts: [[1, "h-100"], ["class", "font-weight-normal mb-0 pb-3", 3, "ngClass", 4, "ngIf"], ["class", "text-sm font-weight-normal mb-0", 4, "ngIf"], [3, "ngClass", 4, "ngIf"], ["class", "text-sm font-weight-normal mt-1", 4, "ngIf"], ["class", "mt-4", 3, "ngClass", 4, "ngIf"], [4, "ngIf"], ["class", "d-flex align-items-end mt-3 justify-content-between", 4, "ngIf"], ["class", "b2c-product-card-tag product-type", 3, "ngClass", 4, "ngIf"], [1, "font-weight-normal", "mb-0", "pb-3", 3, "ngClass"], [4, "nzStringTemplateOutlet"], [1, "text-sm", "font-weight-normal", "mb-0"], [3, "ngClass"], ["role", "button", 1, "font-weight-bold", 3, "click"], ["class", "product-card-watchlist", "nz-tooltip", "", 3, "nzTooltipTitle", "click", 4, "ngIf"], ["nz-tooltip", "", 1, "product-card-watchlist", 3, "nzTooltipTitle", "click"], ["name", "addToWatchlistIcon"], [1, "text-sm", "font-weight-normal", "mt-1"], [1, "mt-4", 3, "ngClass"], ["nz-icon", "", 3, "nzType", "nzTheme"], [1, "d-flex", "align-items-end", "mt-3", "justify-content-between"], ["class", "btn-buy mb-2", "nz-button", "", "nzType", "success", "nzSize", "small", 3, "ngClass", "click", 4, "ngIf"], [1, "b2c-ranking-container"], [1, "b2c-ranking"], [1, "mb-0", "font-weight-bold", "b2c-ranking-num"], ["name", "rankingBgIcon"], ["nz-button", "", "nzType", "success", "nzSize", "small", 1, "btn-buy", "mb-2", 3, "ngClass", "click"], [1, "b2c-product-card-tag", "product-type", 3, "ngClass"], [1, "p-2"], [1, "text-sm"]], template: function B2CProductCardComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelementStart(0, "nz-card", 0);
        ɵngcc0.ɵɵtemplate(1, B2CProductCardComponent_h2_1_Template, 7, 10, "h2", 1);
        ɵngcc0.ɵɵtemplate(2, B2CProductCardComponent_span_2_Template, 2, 1, "span", 2);
        ɵngcc0.ɵɵtemplate(3, B2CProductCardComponent_div_3_Template, 4, 6, "div", 3);
        ɵngcc0.ɵɵtemplate(4, B2CProductCardComponent_div_4_Template, 2, 1, "div", 4);
        ɵngcc0.ɵɵprojection(5);
        ɵngcc0.ɵɵtemplate(6, B2CProductCardComponent_div_6_Template, 7, 11, "div", 5);
        ɵngcc0.ɵɵtemplate(7, B2CProductCardComponent_div_7_Template, 3, 4, "div", 6);
        ɵngcc0.ɵɵtemplate(8, B2CProductCardComponent_div_8_Template, 8, 2, "div", 7);
        ɵngcc0.ɵɵtemplate(9, B2CProductCardComponent_nz_tag_9_Template, 2, 2, "nz-tag", 8);
        ɵngcc0.ɵɵtemplate(10, B2CProductCardComponent_div_10_Template, 4, 1, "div", 6);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.isNumberValue(ctx.highLight) && (ctx.productType.class !== "stock" && ctx.productType.class !== "etf"));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.highlightIndicator);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.productName);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.productSubtitle);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.isNumberValue(ctx.productChange));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.isNumberValue(ctx.productVolume));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.productRanking > 0 || ctx.buyButton);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.productType.name);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.insuranceDesc);
    } }, directives: [ɵngcc1.NzCardComponent, ɵngcc2.NgIf, ɵngcc2.NgClass, ɵngcc3.NzStringTemplateOutletDirective, ɵngcc4.NzTooltipDirective, ɵngcc5.B2CUiIconComponent, ɵngcc6.NzIconDirective, ɵngcc7.NzButtonComponent, ɵngcc8.NzTagComponent], pipes: [ɵngcc9.PnlPipe, ɵngcc2.DecimalPipe], styles: ["\n      .product-ranking-img {\n        height: 67px;\n        width: 66px;\n      }\n\n      .product-ranking-img > * {\n        line-height: 67px;\n      }\n    "], encapsulation: 2, changeDetection: 0 });
B2CProductCardComponent.propDecorators = {
    highLight: [{ type: Input }],
    highLightPrefix: [{ type: Input }],
    highLightSuffix: [{ type: Input }],
    highlightIndicator: [{ type: Input }],
    productName: [{ type: Input }],
    productNameEvent: [{ type: Output }],
    productSubtitle: [{ type: Input }],
    productChange: [{ type: Input }],
    productChangeSuffix: [{ type: Input }],
    productVolume: [{ type: Input }],
    fundType: [{ type: Input }],
    currency: [{ type: Input }],
    insuranceDesc: [{ type: Input }],
    watchlist: [{ type: Input }],
    performanceColor: [{ type: Input }],
    buyButton: [{ type: Input }],
    isWatchListAdded: [{ type: Input }],
    productRanking: [{ type: Input }],
    productTag: [{ type: Input }],
    watchListChange: [{ type: Output }],
    buy: [{ type: Output }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(B2CProductCardComponent, [{
        type: Component,
        args: [{
                selector: 'b2c-product-card',
                exportAs: 'b2cProductCard',
                template: "<nz-card class=\"h-100\">\r\n  <h2 *ngIf=\"isNumberValue(highLight) && (productType.class !== 'stock' && productType.class !== 'etf')\"\r\n      class=\"font-weight-normal mb-0 pb-3\" [ngClass]=\"performanceColor && highLight !== 999999 ? (highLight | pnl:'text') : ''\"\r\n  >\r\n    <span *ngIf=\"highLightPrefix  && highLight !== 999999\">\r\n      <ng-container *nzStringTemplateOutlet=\"highLightPrefix\">{{ highLightPrefix }}</ng-container>\r\n    </span>\r\n    <span>{{ highLight === 999999 ? '-' : (highLight | number: '1.2-2') }}</span>\r\n    <span *ngIf=\"highLightSuffix && highLight !== 999999\">\r\n      <ng-container *nzStringTemplateOutlet=\"highLightSuffix\">{{ highLightSuffix }}</ng-container>\r\n    </span>\r\n  </h2>\r\n\r\n  <span class=\"text-sm font-weight-normal mb-0\" *ngIf=\"highlightIndicator\">\r\n    <ng-container *nzStringTemplateOutlet=\"highlightIndicator\">{{ highlightIndicator }}</ng-container>\r\n  </span>\r\n  <div *ngIf=\"productName\" [ngClass]=\"{'d-flex justify-content-between': watchlist, 'mt-2': productName}\">\r\n    <span class=\"font-weight-bold\" (click)=\"emitProductNameEvent()\" role=\"button\">\r\n      <ng-container *nzStringTemplateOutlet=\"productName\">{{ productName }} </ng-container>\r\n    </span>\r\n    <!-- <ng-template #productNameLink>\r\n        <a external [link]=\"'//' + productNameUrl\" class=\"font-weight-bold text-black-7\">\r\n          <ng-container *nzStringTemplateOutlet=\"productName\">{{ productName }} </ng-container>\r\n        </a>\r\n    </ng-template> -->\r\n    <a (click)=\"onWatchListChange(isWatchListAdded)\" class=\"product-card-watchlist\" *ngIf=\"watchlist\" nz-tooltip\r\n       [nzTooltipTitle]=\"'Add to watchlist'\">\r\n      <b2c-ui-icon\r\n        name=\"addToWatchlistIcon\">\r\n      </b2c-ui-icon>\r\n    </a>\r\n  </div>\r\n  <div class=\"text-sm font-weight-normal mt-1\" *ngIf=\"productSubtitle\">\r\n    <ng-container *nzStringTemplateOutlet=\"productSubtitle\">{{ productSubtitle }}</ng-container>\r\n  </div>\r\n  <ng-content></ng-content>\r\n  <div class=\"mt-4\" *ngIf=\"isNumberValue(productChange)\" [ngClass]=\"performanceColor ? (productChange | pnl:'text') : ''\">\r\n    <i nz-icon [nzType]=\"productChange | pnl:'caret'\" [nzTheme]=\"'fill'\"></i>\r\n    <span>{{ productChange }} </span>\r\n    <span *ngIf=\"productChangeSuffix\">\r\n      <ng-container *nzStringTemplateOutlet=\"productChangeSuffix\">{{ productChangeSuffix }} </ng-container>\r\n    </span>\r\n  </div>\r\n  <div *ngIf=\"isNumberValue(productVolume)\">\r\n    Vol: {{ productVolume | number:'0.2'}}\r\n  </div>\r\n  <div class=\"d-flex align-items-end mt-3 justify-content-between\" *ngIf=\"productRanking > 0 || buyButton\">\r\n    <div>\r\n      <button *ngIf=\"buyButton\" (click)=\"buy.emit()\" class=\"btn-buy mb-2\" [ngClass]=\"{'mt-4': !productRanking > 0}\"\r\n              nz-button nzType=\"success\"\r\n              nzSize=\"small\">Buy\r\n      </button>\r\n    </div>\r\n    <div class=\"b2c-ranking-container\">\r\n      <div class=\"b2c-ranking\">\r\n        <h2 class=\"mb-0 font-weight-bold b2c-ranking-num\">{{ productRanking }}</h2>\r\n        <b2c-ui-icon name=\"rankingBgIcon\"></b2c-ui-icon>\r\n      </div>\r\n    </div>\r\n  </div>\r\n  <nz-tag *ngIf=\"productType.name\" class=\"b2c-product-card-tag product-type\" [ngClass]=\"'bg-' + productType.class\">\r\n    {{ productType.name }}\r\n  </nz-tag>\r\n  <!-- <b2c-fund-risk-rating\r\n    *ngIf=\"productTag\"\r\n    class=\"b2c-product-card-risk-rating\"\r\n    [currency]=\"'MY'\"\r\n    [rating]=\"productTag\"\r\n    [fundType]=\"'balanced'\"\r\n  >\r\n  </b2c-fund-risk-rating> -->\r\n  <div *ngIf=\"insuranceDesc\">\r\n    <hr class=\"p-2\">\r\n    <span class=\"text-sm\">\r\n      <ng-container *nzStringTemplateOutlet=\"insuranceDesc\">{{ insuranceDesc }} </ng-container>\r\n    </span>\r\n  </div>\r\n\r\n\r\n</nz-card>\r\n",
                changeDetection: ChangeDetectionStrategy.OnPush,
                encapsulation: ViewEncapsulation.None,
                styles: [`
      .product-ranking-img {
        height: 67px;
        width: 66px;
      }

      .product-ranking-img > * {
        line-height: 67px;
      }
    `]
            }]
    }], function () { return []; }, { productNameEvent: [{
            type: Output
        }], performanceColor: [{
            type: Input
        }], isWatchListAdded: [{
            type: Input
        }], watchListChange: [{
            type: Output
        }], buy: [{
            type: Output
        }], highLight: [{
            type: Input
        }], productChange: [{
            type: Input
        }], watchlist: [{
            type: Input
        }], buyButton: [{
            type: Input
        }], productTag: [{
            type: Input
        }], highLightPrefix: [{
            type: Input
        }], highLightSuffix: [{
            type: Input
        }], highlightIndicator: [{
            type: Input
        }], productName: [{
            type: Input
        }], productSubtitle: [{
            type: Input
        }], productChangeSuffix: [{
            type: Input
        }], productVolume: [{
            type: Input
        }], fundType: [{
            type: Input
        }], currency: [{
            type: Input
        }], insuranceDesc: [{
            type: Input
        }], productRanking: [{
            type: Input
        }] }); })();
if (false) {
    /**
     * @ignore
     * @type {?}
     * @private
     */
    B2CProductCardComponent.prototype._highLight;
    /**
     * @ignore
     * @type {?}
     * @private
     */
    B2CProductCardComponent.prototype._watchlist;
    /**
     * @ignore
     * @type {?}
     * @private
     */
    B2CProductCardComponent.prototype._buyButton;
    /**
     * @ignore
     * @type {?}
     * @private
     */
    B2CProductCardComponent.prototype._productType;
    /**
     * @ignore
     * @type {?}
     * @private
     */
    B2CProductCardComponent.prototype._productTag;
    /**
     * @ignore
     * @type {?}
     * @private
     */
    B2CProductCardComponent.prototype._productChange;
    /**
     * Set highlight prefix
     * @type {?}
     */
    B2CProductCardComponent.prototype.highLightPrefix;
    /**
     * Set highlight suffix
     * @type {?}
     */
    B2CProductCardComponent.prototype.highLightSuffix;
    /**
     * Set highlight indicator
     * @type {?}
     */
    B2CProductCardComponent.prototype.highlightIndicator;
    /**
     * Set product name
     * @type {?}
     */
    B2CProductCardComponent.prototype.productName;
    /**
     * Product name click event
     * @type {?}
     */
    B2CProductCardComponent.prototype.productNameEvent;
    /**
     * Set product subtitle
     * @type {?}
     */
    B2CProductCardComponent.prototype.productSubtitle;
    /** @type {?} */
    B2CProductCardComponent.prototype.productChangeSuffix;
    /**
     * Set product volume
     * @type {?}
     */
    B2CProductCardComponent.prototype.productVolume;
    /**
     * Set Fund Type for  UTs
     * @type {?}
     */
    B2CProductCardComponent.prototype.fundType;
    /**
     * Set Currency for UTs
     * @type {?}
     */
    B2CProductCardComponent.prototype.currency;
    /**
     * Set insurance description
     * @type {?}
     */
    B2CProductCardComponent.prototype.insuranceDesc;
    /**
     * Set performance color
     * @type {?}
     */
    B2CProductCardComponent.prototype.performanceColor;
    /**
     * Set added watch list
     * @type {?}
     */
    B2CProductCardComponent.prototype.isWatchListAdded;
    /**
     * Set product ranking
     * @type {?}
     */
    B2CProductCardComponent.prototype.productRanking;
    /**
     * Watchlist Change
     * @type {?}
     */
    B2CProductCardComponent.prototype.watchListChange;
    /**
     * Buy button Change
     * @type {?}
     */
    B2CProductCardComponent.prototype.buy;
}

/**
 * @fileoverview added by tsickle
 * Generated from: b2c-product-card-bond-price.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class B2CProductCardBondPriceComponent {
}
B2CProductCardBondPriceComponent.ɵfac = function B2CProductCardBondPriceComponent_Factory(t) { return new (t || B2CProductCardBondPriceComponent)(); };
B2CProductCardBondPriceComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: B2CProductCardBondPriceComponent, selectors: [["b2c-product-card-bond-price"]], inputs: { offerYield: "offerYield", bidYield: "bidYield", offerPrice: "offerPrice", bidPrice: "bidPrice" }, decls: 26, vars: 4, consts: [[1, "b2c-product-card-bond-price"], ["nz-row", "", 1, "mb-2"], ["nz-col", "", "nzSpan", "8"], ["nz-col", "", "nzSpan", "8", 1, "text-right"], [1, "font-weight-bold"], ["nz-row", ""]], template: function B2CProductCardBondPriceComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelement(1, "hr");
        ɵngcc0.ɵɵelementStart(2, "div", 1);
        ɵngcc0.ɵɵelement(3, "div", 2);
        ɵngcc0.ɵɵelementStart(4, "div", 3);
        ɵngcc0.ɵɵtext(5, "Bid");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(6, "div", 3);
        ɵngcc0.ɵɵtext(7, "Ask");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(8, "div", 1);
        ɵngcc0.ɵɵelementStart(9, "div", 2);
        ɵngcc0.ɵɵtext(10, "Yield");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(11, "div", 3);
        ɵngcc0.ɵɵelementStart(12, "span", 4);
        ɵngcc0.ɵɵtext(13);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(14, "div", 3);
        ɵngcc0.ɵɵelementStart(15, "span", 4);
        ɵngcc0.ɵɵtext(16);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(17, "div", 5);
        ɵngcc0.ɵɵelementStart(18, "div", 2);
        ɵngcc0.ɵɵtext(19, "Price");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(20, "div", 3);
        ɵngcc0.ɵɵelementStart(21, "span", 4);
        ɵngcc0.ɵɵtext(22);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(23, "div", 3);
        ɵngcc0.ɵɵelementStart(24, "span", 4);
        ɵngcc0.ɵɵtext(25);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(13);
        ɵngcc0.ɵɵtextInterpolate(ctx.bidYield ? ctx.bidYield.toFixed(3) + "%" : "-");
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵtextInterpolate(ctx.offerYield ? ctx.offerYield.toFixed(3) + "%" : "-");
        ɵngcc0.ɵɵadvance(6);
        ɵngcc0.ɵɵtextInterpolate(ctx.bidPrice ? ctx.bidPrice.toFixed(3) : "-");
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵtextInterpolate(ctx.offerPrice ? ctx.offerPrice.toFixed(3) : "-");
    } }, directives: [ɵngcc10.NzRowDirective, ɵngcc10.NzColDirective], encapsulation: 2, changeDetection: 0 });
B2CProductCardBondPriceComponent.propDecorators = {
    offerYield: [{ type: Input }],
    bidYield: [{ type: Input }],
    offerPrice: [{ type: Input }],
    bidPrice: [{ type: Input }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(B2CProductCardBondPriceComponent, [{
        type: Component,
        args: [{
                changeDetection: ChangeDetectionStrategy.OnPush,
                encapsulation: ViewEncapsulation.None,
                selector: 'b2c-product-card-bond-price',
                template: "<div class=\"b2c-product-card-bond-price\">\r\n\t<hr>\r\n  <div nz-row class=\"mb-2\">\r\n    <div nz-col nzSpan=\"8\"></div>\r\n    <div nz-col nzSpan=\"8\" class=\"text-right\">Bid</div>\r\n    <div nz-col nzSpan=\"8\" class=\"text-right\">Ask</div>\r\n  </div>\r\n  <div nz-row class=\"mb-2\">\r\n    <div nz-col nzSpan=\"8\">Yield</div>\r\n    <div nz-col nzSpan=\"8\" class=\"text-right\">\r\n\t\t\t<span class=\"font-weight-bold\">{{ bidYield ? bidYield.toFixed(3) + '%' : '-'}}</span>\r\n\t\t</div>\r\n    <div nz-col nzSpan=\"8\" class=\"text-right\">\r\n\t\t\t<span class=\"font-weight-bold\">{{ offerYield ? offerYield.toFixed(3) + '%' : '-' }}</span>\r\n\t\t</div>\r\n  </div>\r\n  <div nz-row>\r\n    <div nz-col nzSpan=\"8\">Price</div>\r\n    <div nz-col nzSpan=\"8\" class=\"text-right\">\r\n\t\t\t<span class=\"font-weight-bold\">{{ bidPrice ?  bidPrice.toFixed(3) : '-'}}</span>\r\n\t\t</div>\r\n    <div nz-col nzSpan=\"8\" class=\"text-right\">\r\n\t\t\t<span class=\"font-weight-bold\">{{ offerPrice ? offerPrice.toFixed(3) : '-' }}</span>\r\n\t\t</div>\r\n  </div>\r\n</div>\r\n"
            }]
    }], null, { offerYield: [{
            type: Input
        }], bidYield: [{
            type: Input
        }], offerPrice: [{
            type: Input
        }], bidPrice: [{
            type: Input
        }] }); })();
if (false) {
    /**
     * Set offer yield
     * @type {?}
     */
    B2CProductCardBondPriceComponent.prototype.offerYield;
    /**
     * Set bid yield
     * @type {?}
     */
    B2CProductCardBondPriceComponent.prototype.bidYield;
    /**
     * Set offer yield
     * @type {?}
     */
    B2CProductCardBondPriceComponent.prototype.offerPrice;
    /**
     * Set bid price
     * @type {?}
     */
    B2CProductCardBondPriceComponent.prototype.bidPrice;
}

/**
 * @fileoverview added by tsickle
 * Generated from: b2c-product-card.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
const ICONS = [AddToWatchlistIcon, RankingBgIcon];
class B2CProductCardModule {
    /**
     * @param {?} b2cIconService
     */
    constructor(b2cIconService) {
        this.b2cIconService = b2cIconService;
        this.b2cIconService.registerIcons([...ICONS]);
    }
}
B2CProductCardModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: B2CProductCardModule });
B2CProductCardModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function B2CProductCardModule_Factory(t) { return new (t || B2CProductCardModule)(ɵngcc0.ɵɵinject(ɵngcc5.B2CUiIconService)); }, imports: [[
            CommonModule,
            NzCardModule,
            B2CNgzIconModule,
            NzAddOnModule,
            NzToolTipModule,
            NzButtonModule,
            NzTagModule,
            NzGridModule,
            B2CSharedPipeModule,
            B2cUiIconModule,
            SharedDirectiveModule
        ]] });
/** @nocollapse */
B2CProductCardModule.ctorParameters = () => [
    { type: B2CUiIconService }
];
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(B2CProductCardModule, { declarations: function () { return [B2CProductCardComponent,
        B2CProductCardBondPriceComponent]; }, imports: function () { return [CommonModule,
        NzCardModule,
        B2CNgzIconModule,
        NzAddOnModule,
        NzToolTipModule,
        NzButtonModule,
        NzTagModule,
        NzGridModule,
        B2CSharedPipeModule,
        B2cUiIconModule,
        SharedDirectiveModule]; }, exports: function () { return [B2CProductCardComponent,
        B2CProductCardBondPriceComponent]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(B2CProductCardModule, [{
        type: NgModule,
        args: [{
                declarations: [B2CProductCardComponent, B2CProductCardBondPriceComponent],
                exports: [B2CProductCardComponent, B2CProductCardBondPriceComponent],
                imports: [
                    CommonModule,
                    NzCardModule,
                    B2CNgzIconModule,
                    NzAddOnModule,
                    NzToolTipModule,
                    NzButtonModule,
                    NzTagModule,
                    NzGridModule,
                    B2CSharedPipeModule,
                    B2cUiIconModule,
                    SharedDirectiveModule
                ]
            }]
    }], function () { return [{ type: ɵngcc5.B2CUiIconService }]; }, null); })();
if (false) {
    /**
     * @type {?}
     * @private
     */
    B2CProductCardModule.prototype.b2cIconService;
}

/**
 * @fileoverview added by tsickle
 * Generated from: public_api.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: b2c-ui-product-card.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

export { B2CProductCardBondPriceComponent, B2CProductCardComponent, B2CProductCardModule, productTypeModel };


//# sourceMappingURL=b2c-ui-product-card.js.map